<template>
  <div>
    <div v-if="showSearch" class="d-flex align-items-center mt-8">
      <i class="bi bi-search fs-3 me-3"></i>
      <div>
        <PulsFormInput
          v-model="freeTextFilter"
          class=""
          :placeholder="
            $t('widgetGroupActions.freeText.filterField.placeholder')
          "
        />
      </div>
    </div>
    <div
      v-if="freeTextFilter.length > 0"
      class="alert alert-default"
      role="alert"
    >
      <span class="text-info">
        {{ searchAlertText }}
      </span>
    </div>
    <div class="list-group mt-5">
      <div
        v-for="action in filteredActions"
        :key="action.name"
        class="list-group-item bg-transparent border-0 p-0 mt-2 mb-10"
      >
        <div class="d-flex align-items-center">
          <span v-if="action.numberOfComments" class="fs-4 me-3">
            {{ $tr(action.messages, 'title') }}
          </span>
          <span v-if="action.numberOfComments" class="text-muted">
            {{
              $t('widgetGroupActions.freeText.numberOfComments', {
                numberOfComments: action.numberOfComments
              })
            }}
          </span>
        </div>
        <div
          v-for="actionCategory in actionCategoriesForAction(action)"
          :key="actionCategory.name"
          class="row mt-3 ps-2"
        >
          <div v-if="!selectedCategory" class="col-sm-12">
            <h5 class="mb-2">
              {{ $tr(categories[actionCategory.name]?.messages, 'title') }}
            </h5>
          </div>
          <div
            v-if="!selectedCategory || selectedCategory === actionCategory.name"
            class="col-sm-12 col-xl-12"
          >
            <div class="">
              <div class="freetext-action-group">
                <div
                  v-for="item in actionCategory.values.map((textValue) => ({
                    text: textValue,
                    key: `${actionCategory.name}-${textValue.substr(0, 30)}`
                  }))"
                  :key="item.key"
                  class="action-comment"
                >
                  {{ item.text }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FreetextActions',
  props: {
    actions: Array,
    selectedCategory: String,
    categories: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      freeTextFilter: '',
      minCharsForFilter: 2,
      commentsToShow: {} // not used yet
    }
  },
  computed: {
    filteredActions() {
      const valuesMatchingFilter = (c) =>
        c[Object.keys(c)[0]].values.filter((v) =>
          v.toLowerCase().includes(this.freeTextFilter.toLowerCase())
        )
      return this.actions.reduce((filtered, a) => {
        if (this.freeTextFilter.length === 0) {
          const numberOfComments = a.categories.reduce((res, c) => {
            res = res + c[Object.keys(c)[0]].values.length
            return res
          }, 0)
          filtered.push({ ...a, numberOfComments })
        } else {
          const filteredCategories = a.categories
            .filter((c) => {
              return valuesMatchingFilter(c).length > 0
            })
            .map((c) => {
              const categoryName = Object.keys(c)[0]
              return {
                ...c,
                [categoryName]: {
                  ...c[categoryName],
                  values: valuesMatchingFilter(c)
                }
              }
            })
          const numberOfComments = filteredCategories.reduce((res, c) => {
            const categoryName = Object.keys(c)[0]
            if (
              !this.selectedCategory ||
              categoryName === this.selectedCategory
            ) {
              res = res + c[categoryName].values.length
            }
            return res
          }, 0)
          if (filteredCategories.length > 0) {
            filtered.push({
              ...a,
              categories: filteredCategories,
              numberOfComments
            })
          }
        }
        return filtered
      }, [])
    },
    searchAlertText() {
      if (this.freeTextFilter.length) {
        if (this.freeTextFilter.length <= this.minCharsForFilter) {
          return this.$t('widgetGroupActions.freeText.alert.typeMore')
        } else if (
          this.filteredActions.every((a) => a.categories.length === 0)
        ) {
          return this.$t('widgetGroupActions.freeText.alert.noResults')
        }
      }
      return null
    },
    showSearch() {
      return this.actions.find((action) => {
        const categoryWithManyAnswers = action.categories.find(
          (actionCategories) =>
            actionCategories[Object.keys(actionCategories)[0]].numberOfActions >
            5
        )
        return categoryWithManyAnswers
      })
    }
  },
  watch: {
    freeTextFilter(newFilter, oldFilter) {
      if (newFilter.length === 0) {
        this.setInitialCommentsToShow()
      } else {
        this.setInitialCommentsToShow(5000)
      }
    }
  },
  mounted() {
    this.setInitialCommentsToShow()
  },
  methods: {
    actionCategoriesForAction(action) {
      return action.categories.reduce((res, c) => {
        const categoryName = Object.keys(c)[0]
        if (!this.selectedCategory || this.selectedCategory === categoryName) {
          res.push({ ...c[categoryName], name: categoryName })
        }
        return res
      }, [])
    },
    setInitialCommentsToShow(value = 25) {
      // not done yet
      this.commentsToShow = this.filteredActions.reduce((res, a) => {
        res[a.name] = value
        return res
      }, {})
    }
  }
}
</script>

<style scoped>
.action-comment {
  border: 1px solid var(--kt-gray-600) !important;
  border-radius: var(--bs-card-border-radius);
  padding: 10px;
  color: var(--kt-black);
  background-color: #fdffc9;
  max-width: 440px;
  margin-top: 5px;
  margin-bottom: 10px;
}
</style>
<style lang="scss">
.free-text-actions {
  span {
    font-size: 1rem !important;
    color: var(--kt-gray-800) !important;
  }
}
</style>
